(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44548,65250],{

/***/ 44548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CompareCRMPricesWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/styles/variables/compareCRMPricesVariables.module.scss
var compareCRMPricesVariables_module = __webpack_require__(31754);
var compareCRMPricesVariables_module_default = /*#__PURE__*/__webpack_require__.n(compareCRMPricesVariables_module);
;// CONCATENATED MODULE: ./src/components/comparecrmprices/logo/index.tsx


function CompareCrmPricesLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "338",
        height: "30",
        fill: "none",
        viewBox: "0 0 338 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_15_1324)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#005670",
                        d: "M48.77 24.59a9.647 9.647 0 01-6.95-2.734 9.353 9.353 0 01-2.827-7 9.448 9.448 0 012.877-7.108 9.64 9.64 0 016.979-2.805c1.67-.006 3.317.402 4.791 1.187a8.634 8.634 0 013.425 3.014l-1.907 1.597A7.453 7.453 0 0048.9 7.468a6.985 6.985 0 00-5.144 2.115 7.192 7.192 0 00-2.115 5.33 6.992 6.992 0 007.238 7.195 7.64 7.64 0 003.554-.87 8.482 8.482 0 002.827-2.367l1.856 1.568a9.663 9.663 0 01-3.597 3.014 10.438 10.438 0 01-4.748 1.137zM66.072 24.64a7.044 7.044 0 01-5.223-2.086 7.151 7.151 0 01-2.043-5.173 7.095 7.095 0 017.266-7.237 6.885 6.885 0 015.18 2.115 7.468 7.468 0 010 10.295 6.987 6.987 0 01-5.18 2.086zm4.77-7.259a4.814 4.814 0 00-1.396-3.475 4.604 4.604 0 00-6.741 0 4.812 4.812 0 00-1.396 3.475 4.943 4.943 0 001.396 3.526 4.605 4.605 0 006.74 0 4.942 4.942 0 001.397-3.526zM92.209 10.144a5.23 5.23 0 014.007 1.626 6 6 0 011.496 4.316v8.216h-2.475v-7.82a4.54 4.54 0 00-.884-2.993 3.028 3.028 0 00-2.454-1.05 3.41 3.41 0 00-2.654 1.13 4.216 4.216 0 00-1.03 2.963v7.77H85.77v-7.77a4.554 4.554 0 00-.907-3.014 3.009 3.009 0 00-2.446-1.079 3.445 3.445 0 00-2.662 1.144 4.267 4.267 0 00-1.043 3v7.72h-2.467v-13.8h2.417v2.037a4.467 4.467 0 011.726-1.792c.75-.423 1.6-.632 2.46-.604a5.13 5.13 0 012.598.72 4.037 4.037 0 011.727 1.891 4.82 4.82 0 012.05-1.877 6.345 6.345 0 012.986-.734zM108.734 10.173a6.432 6.432 0 014.921 2.108 7.64 7.64 0 010 10.273 6.481 6.481 0 01-4.943 2.087 5.988 5.988 0 01-4.892-2.346v7.698h-2.475v-19.49h2.475v2.101a6.033 6.033 0 014.914-2.431zm4.431 7.194a4.955 4.955 0 00-1.316-3.504 4.793 4.793 0 00-3.421-1.44 4.79 4.79 0 00-3.421 1.44 5.039 5.039 0 00-1.288 3.504 5.129 5.129 0 001.288 3.554 4.792 4.792 0 003.421 1.44 4.79 4.79 0 003.421-1.44 5.037 5.037 0 001.316-3.54v-.014zM129.518 12.51v-2.006h2.367v13.798h-2.367v-1.957a5.96 5.96 0 01-4.871 2.295 6.477 6.477 0 01-4.942-2.108 7.416 7.416 0 01-1.957-5.23 6.96 6.96 0 011.957-5.1 6.568 6.568 0 014.942-2.03 6.049 6.049 0 014.871 2.339zm.151 4.871a4.977 4.977 0 00-1.309-3.503 4.421 4.421 0 00-3.425-1.44 4.32 4.32 0 00-3.403 1.44 5.482 5.482 0 000 7.057 4.326 4.326 0 003.403 1.44 4.439 4.439 0 003.425-1.44 5.035 5.035 0 001.309-3.554zM138.194 24.302h-2.475V10.504h2.346v2.036a4.124 4.124 0 013.964-2.396 7.123 7.123 0 011.618.209l-.23 2.395a4.737 4.737 0 00-1.439-.237 3.504 3.504 0 00-2.741 1.158 4.808 4.808 0 00-1.043 3.324v7.31zM157.914 17.151c0 .166 0 .59-.079 1.259h-10.993a4.481 4.481 0 004.841 3.935 8.108 8.108 0 002.547-.424 7.906 7.906 0 002.266-1.115l1.058 1.87a9.532 9.532 0 01-2.676 1.374 9.74 9.74 0 01-3.245.554 8.397 8.397 0 01-3.338-.618 5.756 5.756 0 01-2.302-1.67A7.723 7.723 0 01144.705 20a7.968 7.968 0 01-.439-2.655 7.248 7.248 0 011.935-5.15 6.696 6.696 0 015.036-2.03 6.479 6.479 0 014.792 1.878 6.9 6.9 0 011.885 5.108zm-11.072-.878h8.525a3.945 3.945 0 00-1.232-2.83 3.964 3.964 0 00-2.89-1.083 4.165 4.165 0 00-2.878 1.093 4.837 4.837 0 00-1.525 2.82zM169.734 24.59a9.645 9.645 0 01-6.979-2.705 9.357 9.357 0 01-2.805-7.029 9.49 9.49 0 012.877-7.108 9.646 9.646 0 016.979-2.806 10.652 10.652 0 014.734 1.072 8.851 8.851 0 013.453 2.878l-2.569 2.49a6.795 6.795 0 00-5.438-2.756 5.822 5.822 0 00-4.317 1.777 6.032 6.032 0 00-1.748 4.453 5.904 5.904 0 006.05 6.08 6.79 6.79 0 005.533-2.785l2.618 2.367a9.705 9.705 0 01-3.597 2.935 10.664 10.664 0 01-4.791 1.137zM195.273 24.302h-4.453l-4.021-6.92h-2.267v6.92h-3.805V5.281h7.287c2.106 0 3.717.582 4.835 1.748a5.92 5.92 0 011.676 4.273 6.028 6.028 0 01-.993 3.41 5.53 5.53 0 01-2.877 2.158l4.618 7.432zm-7.287-15.496h-3.454v5.15h3.115a3.13 3.13 0 002.209-.719 2.488 2.488 0 00.72-1.885 2.54 2.54 0 00-.72-1.827 2.574 2.574 0 00-1.87-.72zM201.863 24.302h-3.762V5.281h2.525l7.467 10.79 7.389-10.79h2.575v19.021h-3.813V13.511l-5.532 7.957h-1.316l-5.533-7.957v10.791zM222.561 5.28h6.36a5.703 5.703 0 015.727 3.54c.302.743.444 1.543.417 2.345a5.837 5.837 0 01-1.648 4.166 6.352 6.352 0 01-4.741 1.705h-3.539v7.266h-2.576V5.281zm2.576 9.353h3.597a3.721 3.721 0 002.769-1.007 3.68 3.68 0 00.08-4.943 3.268 3.268 0 00-2.511-.978h-3.935v6.928zM240.201 24.302h-2.474V10.504h2.374v2.036a4.121 4.121 0 013.964-2.396 7.123 7.123 0 011.618.209l-.23 2.395a4.737 4.737 0 00-1.439-.237 3.502 3.502 0 00-2.741 1.158 4.808 4.808 0 00-1.043 3.324l-.029 7.31zM249.029 8.547a1.767 1.767 0 01-1.288-.504 1.701 1.701 0 01-.511-1.273 1.667 1.667 0 01.511-1.238 1.813 1.813 0 011.288-.482 1.722 1.722 0 011.237.497 1.654 1.654 0 01.518 1.223 1.742 1.742 0 01-1.755 1.777zm1.187 1.957v13.798h-2.475V10.504h2.475zM260.489 24.611a7.116 7.116 0 01-5.252-2.028 7.023 7.023 0 01-2.036-5.18 7.048 7.048 0 012.058-5.202 7.913 7.913 0 019.101-1.036 5.963 5.963 0 012.51 2.626l-2.028 1.18a5.228 5.228 0 00-1.82-1.849 4.592 4.592 0 00-2.403-.669 4.803 4.803 0 00-3.533 1.439 5.246 5.246 0 000 7.086 4.51 4.51 0 003.425 1.44 4.905 4.905 0 002.482-.72 4.67 4.67 0 001.791-1.777l2.058 1.187a6.371 6.371 0 01-2.576 2.568 7.54 7.54 0 01-3.777.935zM282.295 17.151c0 .166 0 .59-.079 1.259h-10.993a4.484 4.484 0 004.849 3.935 8.076 8.076 0 002.547-.424 7.919 7.919 0 002.266-1.115l1.05 1.87a9.519 9.519 0 01-2.676 1.374 9.703 9.703 0 01-3.245.554 8.397 8.397 0 01-3.338-.618 5.799 5.799 0 01-2.302-1.67A7.745 7.745 0 01269.086 20a8.181 8.181 0 01-.439-2.655 7.245 7.245 0 011.936-5.15 6.686 6.686 0 015.036-2.03 6.474 6.474 0 014.769 1.885 6.892 6.892 0 011.907 5.101zm-11.072-.878h8.525a3.945 3.945 0 00-1.232-2.83 3.964 3.964 0 00-2.89-1.083 4.18 4.18 0 00-2.878 1.093 4.837 4.837 0 00-1.525 2.82zM289.065 24.611a5.938 5.938 0 01-2.971-.77 5.414 5.414 0 01-2.159-2.215l1.777-1.36a4.145 4.145 0 001.504 1.619c.575.364 1.24.56 1.921.568a2.718 2.718 0 001.762-.554 1.685 1.685 0 00.684-1.352 1.937 1.937 0 00-1.259-1.748c-.221-.125-.796-.384-1.727-.777-.856-.36-1.439-.62-1.698-.77a3.64 3.64 0 01-2.115-3.345 3.512 3.512 0 011.245-2.742 4.646 4.646 0 013.273-1.107 5.71 5.71 0 012.518.568c.763.348 1.408.91 1.856 1.619l-1.568 1.496a3.487 3.487 0 00-2.964-1.597 2.095 2.095 0 00-1.439.475 1.525 1.525 0 00-.54 1.194 1.734 1.734 0 001.137 1.611l1.518.67c.642.231 1.267.508 1.871.827a3.746 3.746 0 012.367 3.496 3.806 3.806 0 01-1.439 2.979 5.318 5.318 0 01-3.554 1.215zM295.921 23.396a1.065 1.065 0 01.338-.792 1.1 1.1 0 01.813-.323 1.14 1.14 0 011.069.684c.057.136.085.283.082.43a1.143 1.143 0 01-.704 1.083 1.127 1.127 0 01-.447.083 1.088 1.088 0 01-.813-.33 1.121 1.121 0 01-.338-.835zM304.612 24.518a4.964 4.964 0 01-3.67-1.439 4.887 4.887 0 01-1.438-3.597 4.938 4.938 0 011.438-3.633 5.132 5.132 0 013.741-1.439 5.208 5.208 0 012.619.72 4.186 4.186 0 011.77 1.79l-1.439.828a3.532 3.532 0 00-1.266-1.295 3.232 3.232 0 00-1.684-.467 3.368 3.368 0 00-2.46.985 3.668 3.668 0 000 4.95 3.143 3.143 0 002.396.986 3.4 3.4 0 001.734-.483 3.204 3.204 0 001.244-1.187l1.439.828a4.456 4.456 0 01-1.799 1.798 5.233 5.233 0 01-2.625.655zM315.367 24.54a4.939 4.939 0 01-3.655-1.44 5.043 5.043 0 01-1.439-3.597 4.944 4.944 0 01.351-1.945 4.946 4.946 0 011.088-1.652 4.869 4.869 0 013.655-1.474 4.812 4.812 0 013.597 1.474 5.214 5.214 0 010 7.195 4.858 4.858 0 01-3.597 1.439zm3.324-5.072a3.375 3.375 0 00-.972-2.432 3.23 3.23 0 00-4.712 0 3.392 3.392 0 00-.964 2.432 3.454 3.454 0 00.964 2.489 3.22 3.22 0 003.641.759 3.21 3.21 0 001.071-.76 3.446 3.446 0 00.972-2.488zM333.626 14.41a3.663 3.663 0 012.806 1.137 4.202 4.202 0 011.043 3.021v5.756h-1.727v-5.468a3.136 3.136 0 00-.618-2.086 2.107 2.107 0 00-1.698-.72 2.405 2.405 0 00-1.856.792 2.971 2.971 0 00-.72 2.065v5.431h-1.705V18.87a3.159 3.159 0 00-.633-2.1 2.09 2.09 0 00-1.705-.72 2.412 2.412 0 00-1.863.799 3 3 0 00-.72 2.093v5.396h-1.726v-9.676h1.69V16.1a3.09 3.09 0 011.194-1.252 3.305 3.305 0 011.72-.425 3.598 3.598 0 011.813.482c.526.293.945.747 1.194 1.295a3.426 3.426 0 011.439-1.309 4.442 4.442 0 012.072-.482z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F15B4B",
                        d: "M13.022 11.777a1.805 1.805 0 002.59 0l5.064-5.28a2.316 2.316 0 00.576-2.353c-.187-.511-.525-.878-.943-.878h-2.374a3.713 3.713 0 01-7.41 0H8.187c-.417 0-.763.367-.942.878a2.28 2.28 0 00.582 2.352l5.195 5.28z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#2CC0D2",
                        d: "M11.9 12.763L6.625 7.662a2.28 2.28 0 00-2.345-.568c-.518.18-.885.518-.885.935v2.259a3.712 3.712 0 010 7.396v2.496c0 .424.367.763.885.942a2.273 2.273 0 002.345-.604l5.288-5.201a1.793 1.793 0 00-.015-2.554z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#005670",
                        d: "M15.496 15.791a1.806 1.806 0 00-2.582 0l-5.1 5.28a2.31 2.31 0 00-.57 2.325c.18.518.526.877.943.877h2.475a3.712 3.712 0 017.194 0h2.475c.417 0 .72-.36.942-.877a2.302 2.302 0 00-.597-2.317l-5.18-5.288z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FBAC18",
                        d: "M21.777 13.986a3.72 3.72 0 013.345-3.698V7.79c0-.417-.367-.755-.877-.942a2.31 2.31 0 00-2.353.583l-5.28 5.172a1.805 1.805 0 000 2.583l5.28 5.1a2.31 2.31 0 002.345.569c.511-.18.878-.525.878-.942v-2.23a3.712 3.712 0 01-3.338-3.699z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F15B4B",
                        d: "M14.259 0a3.036 3.036 0 00-3.029 3.029v.237a3.029 3.029 0 006.036 0V3.03A3.036 3.036 0 0014.26 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#005670",
                        d: "M17.151 24.302a3.029 3.029 0 00-5.755 0 2.992 2.992 0 00-.144.914 3.035 3.035 0 106.065 0 2.994 2.994 0 00-.166-.914z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FBAC18",
                        d: "M25.49 10.957a3.119 3.119 0 00-.368 0 3.029 3.029 0 000 6.014c.122.007.245.007.367 0a3.036 3.036 0 100-6.065v.05z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#2CC0D2",
                        d: "M3.41 10.978a2.994 2.994 0 00-.367 0 3.036 3.036 0 000 6.065c.122.008.245.008.367 0a3.03 3.03 0 000-6.014v-.05z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_15_1324",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H337.475V30H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (CompareCrmPricesLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/compareCrmPricesWrapper.tsx









const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function CompareCRMPricesWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "CRM Software",
                    domain: "CompareCRMPrices.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "CRM Software",
                    domain: "CompareCRMPrices.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "TOP CRM SOFTWARE COMPANIES",
                        textColor: (compareCRMPricesVariables_module_default()).offerCallNumber,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 31754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColor":"#16556d","primaryColor":"#005670","green":"#5bc1a4","whyUsTitle":"#2e2e2e","whyUsItemTitle":"#005670","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453"};

/***/ })

}]);